import React, { useEffect, useState, useRef } from "react";

interface ModalRightProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ModalRight: React.FC<ModalRightProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  const [displayed, setDisplayed] = useState(false);
  const [mouseDownInsideModal, setMouseDownInsideModal] = useState(false);

  const handleBackdropClick = (e: React.MouseEvent) => {
    // Only close if the mousedown didn't start inside the modal content
    if (!mouseDownInsideModal && e.target === e.currentTarget) {
      // onClose();
    }
  };

  const mouseDownTargetRef = useRef(null);

  const handleMouseDown = (e: any) => {
    // Store where the mouse down event occurred
    mouseDownTargetRef.current = e.target;
  };

  const handleMouseUp = (e: any) => {
    // Only close if both mousedown and mouseup happened on the backdrop
    const isBackdropTarget = (target: any) => {
      return (
        target.classList.contains("modal-backdrop") ||
        target.classList.contains("modal-content-wrapper")
      );
    };

    if (!mouseDownTargetRef.current) {
      return;
    }

    const mouseDownOnBackdrop =
      mouseDownTargetRef.current &&
      isBackdropTarget(mouseDownTargetRef.current);

    const mouseUpOnBackdrop = isBackdropTarget(e.target);

    if (mouseDownOnBackdrop === true && mouseUpOnBackdrop === true) {
      e.stopPropagation(); // Prevent event from bubbling up
      setDisplayed(false);
      setTimeout(() => {
        onClose();
      }, 300); // Match the duration of the transition
    } else {
      e.stopPropagation(); // Prevent event from bubbling up
    }

    // Reset the ref
    mouseDownTargetRef.current = null;
  };

  useEffect(() => {
    if (isOpen) {
      setDisplayed(true);
    } else {
      const timer = setTimeout(() => {
        setDisplayed(false);
      }, 300); // Match the duration of the transition
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  return (
    <div
      className="modal-backdrop fixed inset-0 flex h-screen w-screen flex-row items-end justify-end bg-black bg-opacity-25 z-60 cursor-default"
      onClick={handleBackdropClick}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      <div
        className=" modal-content-wrapper items-center  flex-row justify-end flex py-4 pr-6"
        onClick={handleBackdropClick}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        style={{
          overflowY: "auto",
          overflowX: "hidden",
          height: "100vh",
          width: "100vw",
        }}
      >
        <div
          className={` bg-white rounded-xl h-full overflow-y-auto duration-500 ease-in-out 
            ${
              displayed
                ? "translate-x-0 w-fit opacity-100"
                : "translate-x-full w-0 max-w-0 opacity-0"
            }
            translate-x-2`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalRight;
